import { QueryClientProvider } from '@tanstack/react-query';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { queryClient } from './lib/queryClient.js';
import { Layout } from './components/Layout.js';
import { MapPage } from './pages/MapPage.js';
import { ChartPage } from './features/historical/ChartPage.js';

// NOTE on season gating: prior to the historical-mode addition, the entire
// app was hidden behind `isInService()` outside the env-ministry WBGT window.
// Historical mode is meaningful year-round (it shows past summers), so the
// app shell is now always reachable; the seasonal gate has been moved into
// MapPage so it now applies to the forecast tab only.

export function App() {
  // The per-prefecture chart opens in a new tab as `/?view=chart&code=..&year=..`.
  // Using the root path (with query params) avoids any SPA deep-link / 404
  // fallback concerns on Cloudflare Pages.
  const params = new URLSearchParams(window.location.search);
  if (params.get('view') === 'chart') {
    const code = params.get('code') ?? '';
    const year = params.get('year') ?? '2025';
    return (
      <QueryClientProvider client={queryClient}>
        <ChartPage code={code} initialYear={year} />
      </QueryClientProvider>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<MapPage />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  );
}
